/* eslint-disable no-unused-vars */
import mapboxgl from "mapbox-gl";
import { Loader } from "@googlemaps/js-api-loader";

const projectLocation = {
  coordinates: [8.436780274048768, 47.41799655481021],
};

if (document.querySelector("#map")) {
  mapboxgl.accessToken = "pk.eyJ1IjoiY3Jlb3MiLCJhIjoiY2xhOXN0anZtMDE3YzNwb2U4a2s3emNxcSJ9.zBFvjwbyVgUjY9LE5oBNtw";

  const tabs = document.querySelectorAll(".tab");

  const layers = Array.from(tabs).map((tab) => {
    return tab.getAttribute("data-id");
  });

  let activeLayerId;
  let activeLayer;

  const map = new mapboxgl.Map({
    container: "map", // container ID
    style: "mapbox://styles/mapbox/light-v10",
    center: projectLocation.coordinates, // starting position [lng, lat]
    zoom: 14, // starting zoom
    // scrollZoom: false,
    boxZoom: true,
  });
  map.addControl(new mapboxgl.NavigationControl());

  map.scrollZoom.disable();
  map.scrollZoom.setWheelZoomRate(0.02); // Default 1/450

  map.on("wheel", (event) => {
    if (event.originalEvent.metaKey || event.originalEvent.shiftKey) {
      // Check if key is pressed
      event.originalEvent.preventDefault(); // Prevent chrome/firefox default behavior
      if (!map.scrollZoom._enabled) map.scrollZoom.enable(); // Enable zoom only if it's disabled
    } else {
      //alert("Scroll with Shift or CMD"); //Change to nice alert
      map.scrollZoom.disable(); // Disable zoom only if it's enabled
    }
  });

  //Only allow two finger drag on mobile
  const isTouchEvent = (e) => e.originalEvent && "touches" in e.originalEvent;
  const isTwoFingerTouch = (e) => e.originalEvent.touches.length >= 2;

  map.on("dragstart", (event) => {
    if (isTouchEvent(event) && !isTwoFingerTouch(event)) {
      map.dragPan.disable();
    }
  });

  // Drag events not emited after dragPan disabled, so I use touch event here
  map.on("touchstart", (event) => {
    if (isTouchEvent(event) && isTwoFingerTouch(event)) {
      map.dragPan.enable();
    }
  });

  tabs.forEach((tab) => {
    // add event listener
    tab.addEventListener("click", async (ev) => {
      removeAllLayers(layers, map);
      activeLayerId = ev.target.closest("li").getAttribute("data-id");
      activeLayer = await getJSON(activeLayerId);

      // Center map
      map.jumpTo({
        center: projectLocation.coordinates,
        zoom: 12,
      });

      if (activeLayer) {
        map.addLayer({
          id: activeLayerId,
          type: "symbol",
          /* Add a GeoJSON source containing place coordinates and information. */
          source: {
            type: "geojson",
            data: activeLayer,
          },
          layout: {
            "icon-image": "circle",
            "text-field": ["format", ["get", "id"], { "text-color": "white" }],
          },
        });

        // add active class
        const activeItem = document.querySelector("#map-container .tabs .tab.active");
        if (activeItem) {
          activeItem.classList.remove("active");
        }
        tab.classList.add("active");

        buildList(activeLayer, map);
      }
    });
  });

  // add center marker on load
  map.on("load", async () => {
    /* Add the data to your map as a layer */
    const locationMarker = new mapboxgl.Marker({
      color: "var(--wp--preset--color--dark)",
    })
      .setLngLat(projectLocation.coordinates)
      .addTo(map);

    // Get first layer
    activeLayerId = tabs[0].closest("li").getAttribute("data-id");
    activeLayer = await getJSON(activeLayerId);

    // add circle image to map
    const circle = new Image(25, 25);
    circle.onload = () => map.addImage("circle", circle);
    circle.src =
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Ccircle id='Ellipse_1' data-name='Ellipse 1' style='fill: %23505050;' cx='5' cy='5' r='5'/%3E%3C/svg%3E";

    if (activeLayer) {
      map.addLayer({
        id: activeLayerId,
        type: "symbol",
        /* Add a GeoJSON source containing place coordinates and information. */
        source: {
          type: "geojson",
          data: activeLayer,
        },
        layout: {
          "icon-image": "circle",
          "text-field": ["format", ["get", "id"], { "text-color": "white" }],
        },
      });

      // add active class
      const activeItem = document.querySelector("#map-container .tabs .tab.active");
      if (activeItem) {
        activeItem.classList.remove("active");
      }
      //First tab active on load
      tabs[0].classList.add("active");

      buildList(activeLayer, map);
    }
  });

  // connect markers to list
  map.on("click", async (event) => {
    /* Determine if a feature in the "locations" layer exists at that point. */
    const features = map.queryRenderedFeatures(event.point, {
      layers: [activeLayerId],
    });

    /* If it does not exist, return */
    if (!features.length) {
      removeActivePopup();
      removeActiveListItem();

      return;
    }

    const clickedPoint = activeLayer.features[features[0].id];

    /* Fly to the point */
    jumpToLocation(clickedPoint, map);

    /* Close all other popups and display popup for clicked store */
    await createPopUp(clickedPoint, map);

    /* Highlight listing in sidebar (and remove highlight for all other listings) */
    removeActiveListItem();
    const listing = document.getElementById(`listing-${clickedPoint.id}`);
    listing.classList.add("active");
  });
}

async function getJSON(activeLayerId) {
  //get json with activeLayerId
  const layer = await fetch(`../wp-content/themes/creos/assets/json/${activeLayerId}.json`).then((response) => response.json());
  /* Assign a unique ID to each store */
  layer.features.forEach(function (store, i) {
    store.id = i;
    store.properties.id = i + 1;
  });
  return layer;
}

async function buildList(layer, map) {
  const listings = document.getElementById("list");

  listings.innerHTML = "";

  for (const feature of layer.features) {
    /* Add a new listing section to the sidebar. */
    const listing = listings.appendChild(document.createElement("li"));
    /* Assign a unique `id` to the listing. */
    listing.id = `listing-${feature.id}`;
    /* Assign the `item` class to each listing for styling. */
    listing.className = "item";

    /* Add the link to the individual listing created above. */
    const link = listing.appendChild(document.createElement("a"));
    link.href = "#";
    link.className = "title";
    link.id = `link-${feature.id}`;
    link.innerHTML = `<span class="number">${feature.properties.id}</span> ${feature.text}`;

    /* Add details to the individual listing. */

    if (feature.properties.id) {
      const details = link.appendChild(document.createElement("span"));
      details.innerHTML = `${feature.properties.address ? feature.properties.address : ""}`;
    }

    // add popups
    link.addEventListener("click", async function (e) {
      e.preventDefault();

      for (const goToFeature of layer.features) {
        if (this.id === `link-${goToFeature.id}`) {
          jumpToLocation(goToFeature, map);
          await createPopUp(goToFeature, map);
        }
      }
      removeActiveListItem();
      this.parentNode.classList.add("active");
    });
  }
}

function jumpToLocation(currentFeature, map) {
  map.jumpTo({
    center: currentFeature.geometry.coordinates,
    // zoom: 15,
  });
}

async function createPopUp(currentFeature, map) {
  removeActivePopup();

  const distances = await getDistances(projectLocation.coordinates, currentFeature.geometry.coordinates);

  const popup = new mapboxgl.Popup({ closeOnClick: false })
    .setLngLat(currentFeature.geometry.coordinates)
    .setHTML(
      `<p><b>${currentFeature.text}</b></p>
      <p class="profile"><b>Auto:</b> ${distances.DRIVING.distance + ", " + distances.DRIVING.duration}</p>
      <p class="profile"><b>ÖV:</b> ${distances.TRANSIT.distance + ", " + distances.TRANSIT.duration}</p>
      <p class="profile"><b>Fuss:</b> ${distances.WALKING.distance + ", " + distances.WALKING.duration}</p>
      <p class="profile"><b>Velo:</b> ${distances.BICYCLING.distance + ", " + distances.BICYCLING.duration}</p>
      `
    )
    .addTo(map);
}

function removeActiveListItem() {
  const activeItem = document.querySelector("#map-container #list .item.active");
  if (activeItem) {
    activeItem.classList.remove("active");
  }
}

function removeActivePopup() {
  const popUps = document.getElementsByClassName("mapboxgl-popup");
  /** Check if there is already a popup on the map and if so, remove it */
  if (popUps[0]) popUps[0].remove();
}

function removeAllLayers(layers, map) {
  removeActivePopup();
  layers.forEach((layer) => {
    if (map.getLayer(layer)) {
      map.removeLayer(layer);
    }
    if (map.getSource(layer)) {
      map.removeSource(layer);
    }
  });
}

async function getDistances(origin, destination) {
  const loader = new Loader({
    apiKey: "AIzaSyA-0aPVXz1IYO9DJI1cg3v3_eO-3pAHbaQ",
    version: "weekly",
    // libraries: ["distances"],
  });
  const profiles = ["DRIVING", "TRANSIT", "WALKING", "BICYCLING"];

  //coordinates different order for mapbox
  origin = {
    lat: origin[1],
    lng: origin[0],
  };
  destination = {
    lat: destination[1],
    lng: destination[0],
  };
  // const lat = origin[1];
  // const lng = origin[0];

  const response = await loader
    .load()
    .then((google) => {
      const service = new google.maps.DistanceMatrixService();

      const results = profiles.map((profile) => {
        const request = {
          // origins: [origin.toString()],
          origins: [origin],
          destinations: [destination],
          travelMode: google.maps.TravelMode[profile],
          transitOptions: {},
          unitSystem: google.maps.UnitSystem.METRIC,
          avoidHighways: false,
          avoidTolls: false,
        };

        return service.getDistanceMatrix(request).then((res) => {
          const obj = {};
          obj[profile] = {};
          obj[profile].distance = res.rows[0].elements[0].distance.text;
          obj[profile].duration = res.rows[0].elements[0].duration.text.replace("Minuten", "min").replace("Stunde,", "h");
          return obj;
        });
      });

      return Promise.all(results).then((val) => {
        return val.reduce((previousValue, currentValue) => {
          previousValue[Object.keys(currentValue)[0]] = currentValue[Object.keys(currentValue)[0]];
          return previousValue;
        }, {});
      });
    })
    .catch((e) => {
      // do something
    });

  return response;
}
